import {
  AccountBalance as AccountBalanceIcon,
  Add as AddIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
  AttachMoney as AttachMoneyIcon,
  CheckCircle as CheckCircleIcon,
  CompareArrows as CompareArrowsIcon,
  Dashboard as DashboardIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  FileDownload as FileDownloadIcon,
  Gavel as GavelIcon,
  Help as HelpIcon,
  HelpOutline as HelpOutlineIcon,
  Info as InfoIcon,
  Insights as InsightsIcon,
  KeyboardArrowLeftRounded as KeyboardArrowLeftRoundedIcon,
  KeyboardArrowRightRounded as KeyboardArrowRightRoundedIcon,
  Launch as LaunchIcon,
  Lock as LockIcon,
  Menu as MenuIcon,
  PanTool as PanToolIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  Star as StarIcon,
  StarOutline as StarOutlinedIcon,
  Store as StoreIcon
} from '@mui/icons-material';

export const iconMap: Record<string, React.ComponentType<any>> = {
  add: AddIcon,
  arrow_forward_ios: ArrowForwardIosIcon,
  attach_money: AttachMoneyIcon,
  check_circle: CheckCircleIcon,
  compare_arrows: CompareArrowsIcon,
  dashboard: DashboardIcon,
  delete: DeleteIcon,
  edit: EditIcon,
  expand_less: ExpandLessIcon,
  expand_more: ExpandMoreIcon,
  file_download: FileDownloadIcon,
  gavel: GavelIcon,
  help: HelpIcon,
  help_outline: HelpOutlineIcon,
  info: InfoIcon,
  insights: InsightsIcon,
  keyboard_arrow_right_rounded: KeyboardArrowRightRoundedIcon,
  keyboard_arrow_left_rounded: KeyboardArrowLeftRoundedIcon,
  launch: LaunchIcon,
  'lock-icon': LockIcon,
  menu: MenuIcon,
  pan_tool: PanToolIcon,
  people: PeopleIcon,
  settings: SettingsIcon,
  star: StarIcon,
  star_outlined: StarOutlinedIcon,
  store: StoreIcon,
  account_balance: AccountBalanceIcon
};
